<template>
  <li v-if="feature" class="row">
    <div v-if="featureLabel && feature" class="title" :class="determineFeatureClass">
      {{ featureLabel }}: {{ feature.Name }}
    </div>
    <div v-else class="title" :class="determineFeatureClass">
      {{ feature.Name }}
    </div>
    <div class="code" :class="determineFeatureClass">
      <small>{{ feature.ShortId }}</small>
    </div>
    <div class="price price-incl" :class="determineFeatureClass">
      {{ priceIncl }}
    </div>
    <div v-if="feature.LegacyOption && canChange.Allowed" class="info-icon">
      <i class="fa-solid fa-info-circle" title="Deze optie is niet langer beschikbaar."></i>
    </div>
    <div v-if="canChange.Allowed" class="edit-dialog" @click="editFeature">
      <i class="fa-solid fa-pencil"></i>
    </div>
    <div
      v-if="!canChange.Allowed && canChange.Reason !== ''"
      class="edit-dialog"
      :title="canChange.Reason"
    >
      <i class="fa-solid fa-lock"></i>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    canDetectFeatureChange: {
      type: Boolean,
      required: false,
    },
    originalFeature: {
      type: Object,
      default: null,
    },
    originalFeatures: {
      type: Object,
      default: null,
    },
    feature: {
      type: Object,
      default: null,
    },
    featureLabel: {
      type: String,
      default: '',
    },
    canChange: {
      type: Object,
      default: () => ({
        Allowed: false,
        Reason: '',
      }),
    },
    reason: {
      type: String,
      default: '',
    },
  },
  emits: ['feature-edit-requested'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      openEditDialog: false,
    }
  },
  computed: {
    priceIncl() {
      if (this.feature.Price) {
        return Number.parseFloat(this.feature.Price.Incl) !== 0
          ? this.i18n.n(this.feature.Price.Incl, 'currency')
          : 'Geen meerprijs'
      }
      return 'prijs onbekend'
    },
    determineFeatureClass() {
      if (this.hasFeatureChanged && this.canDetectFeatureChange) {
        return 'feature-changed'
      }
      if (this.feature.LegacyOption && this.canChange.Allowed) {
        return 'feature-is_legacy_option'
      }
      return ''
    },
    hasFeatureChanged() {
      if (this.originalFeature != null) {
        return this.originalFeature.ShortId !== this.feature.ShortId
      }
      if (this.originalFeatures != null) {
        return !this.originalFeatures.some((option) => option.ShortId === this.feature.ShortId)
      }
      return false
    },
  },
  methods: {
    editFeature() {
      this.$emit('feature-edit-requested', this.feature)
    },
  },
}
</script>

<style lang="scss" scoped>
.info-icon {
  cursor: pointer;
}
.edit-dialog {
  cursor: pointer;
}
.feature-changed {
  background-color: #fff8b9;
}
.feature-is_legacy_option {
  background-color: rgba(231, 6, 6, 0.5);
}
</style>
